import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const invoiceColdefs = [
    // {
    //     field: "sR.No",
    //     headerName: "Sr No",
    //     minWidth: window.innerWidth * 0.05,
    //     flex: 0.4,
    //     filter: true,
    // },
    {
        field: "product",
        headerName: "Product",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
    },
    {
        field: "rate",
        headerName: "Rate",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "amount",
        headerName: "Amount",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "taxGroup",
        headerName: "Tax group",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "cgst",
        headerName: "CGST",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "cgstAmt",
        headerName: "CGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "sgst",
        headerName: "SGST",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "sgstAmt",
        headerName: "SGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "igst",
        headerName: "IGST",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "igstAmt",
        headerName: "IGST Amt",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "netTotal",
        headerName: "Net total",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },

];

export const ManuallyInvoicePopup = (props) => {
    return (
        <ModalBasic
            id="manual-invoice"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Invoice details</span>
                <div className='item-grp grid grid-cols-6 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200'>
                    <div className='input-grp'>
                        <label>Invoice no</label>
                        <TextInput type='text'
                            id='invoiceNo' name='invoiceNo'
                            value={props.invoiceObject.invoiceNo}
                            handleChange={(event) => props.handleChangeForInvoice(event, 'invoiceNo')}
                            className={props.validState?.error?.invoiceNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Invoice date</label>
                        <TextInput type='date'
                            id='invoiceDate' name='invoiceDate'
                            value={props.invoiceObject.invoiceDate}
                            handleChange={(event) => props.handleChangeForInvoice(event, 'invoiceDate')}
                            className={props.validState?.error?.invoiceDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Ref. no</label>
                        <TextInput type='number'
                            id='refNo' name='refNo'
                            value={props.invoiceObject.refNo}
                            handleChange={(event) => props.handleChangeForInvoice(event, 'refNo')}
                            className={props.validState?.error?.refNo !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Ref. date</label>
                        <TextInput type='date'
                            id='refDate' name='refDate'
                            value={props.invoiceObject.refDate}
                            handleChange={(event) => props.handleChangeForInvoice(event, 'refDate')}
                            className={props.validState?.error?.refDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Account head</label>
                        <MultiSelectDropdown
                            drpIdentity="Select accHead"
                            options={props.accountHeadList}
                            value={props.invoiceObject.idAccountHead ? props.accountHeadList.find(x => x.value === props.invoiceObject.idAccountHead) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idAccountHead")
                            }
                            className={props.validState?.error?.idAccountHead !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Select customer</label>
                        <MultiSelectDropdown
                            drpIdentity="Select customer"
                            options={props.partyAccountList}
                            value={props.invoiceObject.idCustomer ? props.partyAccountList.find(x => x.value === props.invoiceObject.idCustomer) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "idCustomer")
                            }
                            className={props.validState?.error?.idCustomer !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Tax type</label>
                        <MultiSelectDropdown
                            drpIdentity="Tax type"
                            options={props.taxList}
                            value={props.invoiceObject.taxTypeId ? props.taxList.find(x => x.value === props.invoiceObject.taxTypeId) : 0}
                            onChange={(event) =>
                                props.setFilterParameters(event, "taxTypeId")
                            }
                            className={props.validState?.error?.taxTypeId !== undefined ? "error" : ""}
                        />

                    </div>

                </div>
                <span className="text-blue text-[16px] font-semibold">Invoice item details</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp col-span-2'>
                        <label>Product</label>
                        <TextInput type='text'
                            id='product' name='product'
                            value={props.invoiceItem.product}
                            handleChange={(event) => props.handleChangeForInvoiceItem(event, 'product')}
                            className={props.validState?.error?.product !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.invoiceItem.quantity}
                            handleChange={(event) => props.handleChangeForInvoiceItem(event, 'quantity')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                        />

                    </div>

                    <div className='input-grp'>
                        <label>Rate</label>
                        <TextInput type='number'
                            id='rate' name='quantity'
                            value={props.invoiceItem.rate}
                            handleChange={(event) => props.handleChangeForInvoiceItem(event, 'rate')}
                            className={props.validState?.error?.rate !== undefined ? "error" : ""}
                        />
                    </div>

                    <div className='input-grp'>
                        <label>Amount</label>
                        <TextInput type='number'
                            id='amount' name='amount'
                            value={props.invoiceItem.amount}
                            handleChange={(event) => props.handleChangeForInvoiceItem(event, 'amount')}
                            disabled
                        />
                    </div>

                    <div className='input-grp'>
                        <label>Tax group</label>
                        <MultiSelectDropdown
                            drpIdentity="idTaxStructure"
                            options={props.texStructureList}
                            value={props.invoiceItem.idTaxStructure ? props.texStructureList.find(x => x.value === props.invoiceItem.idTaxStructure) : 0}
                            onChange={(event) =>
                                props.setFilterParametersForInvoiceItem(event, "idTaxStructure")
                            }
                            className={props.validState?.error?.idTaxStructure !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className="input-grp">
                        <label>SGST</label>
                        <TextInput type="number"
                            id="sgst" name="sgstAmt"
                            value={props.invoiceItem.sgstAmt}
                            handleChange={(event) => props.handleChangeForInvoiceItem(event, "sgst")}
                            className={props.validState?.error?.sgst !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>

                    <div className="input-grp">
                        <label>CGST</label>
                        <TextInput type="number"
                            id="cgst" name="cgstAmt"
                            value={props.invoiceItem.cgstAmt}
                            handleChange={(event) => props.handleChangeForInvoiceItem(event, "cgst")}
                            className={props.validState?.error?.cgst !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>

                    <div className="input-grp">
                        <label>IGST</label>
                        <TextInput type="number"
                            id="igst" name="igstAmt"
                            value={props.invoiceItem.igstAmt}
                            handleChange={(event) => props.handleChangeForInvoiceItem(event, "igst")}
                            className={props.validState?.error?.igst !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>

                    <div className="input-grp">
                        <label>Net total</label>
                        <TextInput type="number"
                            id="netTotal" name="netTotal"
                            value={props.invoiceItem.netTotal}
                            handleChange={(event) => props.handleChangeForInvoiceItem(event, "netTotal")}
                            className={props.validState?.error?.netTotal !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>

                    <div className="input-grp col-span-2">
                        <label>Remarks</label>
                        <TextInput type="text"
                            id="remarks" name="remarks"
                            value={props.invoiceItem.remarks}
                            handleChange={(event) => props.handleChangeForInvoiceItem(event, "remarks")}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>

                    <div className='btn-grp flex gap-2.5 mt-5'>
                        {props.invoiceItem && props.invoiceItem.index === null ?
                            <div className="input-grp">
                                <button className="save-btn btns mt-auto mb-[2px]" onClick={() => props.insertItem("Insert")}> Insert</button>
                            </div>
                            :
                            <div className="input-grp flex items-center gap-2.5">
                                <button className="save-btn btns mt-auto mb-[2px]" onClick={() => props.insertItem("Update")}> Update</button>
                                <button className="delete-btn btns mt-auto mb-[2px]" onClick={() => props.deleteItem()}> Delete</button>
                            </div>
                        }
                    </div>
                </div>
                <div className="process-table h-[30vh]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.invoiceRowData}
                            columnDefs={invoiceColdefs}
                            onCellClicked={props.onRowDoubleClickedForManualInvoiceDetails}
                        />
                    </div>
                </div>
                <div className='total-amt mt-2.5 p-2.5 bg-[#3f8cff1a] rounded-[10px]'>
                    <span className="text-blue text-[16px] font-semibold">Amount details</span>
                    <div className='input-grp-outer grid grid-cols-8 gap-2.5 mt-2.5'>
                        <div className='input-grp'>
                            <label>Total quantity</label>
                            <TextInput type='number'
                                id='totalQuantity' name='totalQuantity'
                                value={props.paymentDetails.totalQuantity}
                                // handleChange={(event) => props.handleChangeForPayment(event, 'totalQuantity')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Taxable amount</label>
                            <TextInput type='number'
                                id='totalAmt' name='totalAmt'
                                value={props.paymentDetails.totalAmt}
                                // handleChange={(event) => props.handleChangeForPayment(event, 'totalAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Tax amount</label>
                            <TextInput type='number'
                                id='taxAmt' name='taxAmt'
                                value={props.paymentDetails.taxAmt}
                                // handleChange={(event) => props.handleChangeForPayment(event, 'taxAmt')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Total with tax</label>
                            <TextInput type='number'
                                id='totalWithTax' name='totalWithTax'
                                value={props.paymentDetails.totalWithTax}
                                //handleChange={(event) => props.handleChangeForPayment(event, 'totalWithTax')}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Adjustable amount</label>
                            <TextInput type='number'
                                id='adjustableAmt' name='adjustableAmt'
                                value={props.paymentDetails.adjustableAmt}
                                handleChange={(event) => props.handleChangeForPayment(event, 'adjustableAmt')}
                                className='font-semibold'
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Final amount</label>
                            <TextInput type='number'
                                id='finalAmt' name='finalAmt'
                                value={props.paymentDetails.finalAmt}
                                // handleChange={(event) => props.handleChangeForPayment(event, 'finalAmt')}
                                className='font-semibold'
                                disabled
                            />
                        </div>
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}